let env = {};

env.baseURL = 'https://api.news.innovsign.com.br/api/v1/';
env.normalURL = 'https://api.news.innovsign.com.br/';

export default env



// WEBPACK FOOTER //
// ./src/config/env.js